import React from "react";
import AboutSection from "../Components/Homepage/AboutSection";
import CarouselSection from "../Components/Homepage/CarouselSection";
import CountsSection from "../Components/Homepage/CountsSection";
import HeroSection from "../Components/Homepage/HeroSection";
import ProcessSection from "../Components/Homepage/ProcessSection";
import RatesSection from "../Components/Homepage/RatesSection";
import ReportsSection from "../Components/Homepage/ReportsSection";
import SignupSection from "../Components/Homepage/SignupSection";
import TermsSection from "../Components/Homepage/TermsSection";

export default function HomePage() {
  return (
    <div className="home-container">
      <HeroSection />
      <ProcessSection />
      {/* <AboutSection /> */}
      <ReportsSection />
      <RatesSection />
      <TermsSection />
      <CountsSection />
      <CarouselSection />
      {/* <SignupSection /> */}
    </div>
  );
}
